module.exports = __webpack_public_path__ + "media/images/logos/logo-rafi-1a32527530562e2e99a523254841bcc0.svg";